/** Extracts the UTC calendar date before constructing a local `Date`, so a negative-UTC-offset timezone
 * never displays the previous day — the same pitfall `formatReportDate` (reports feature) already guards
 * against, applied here since these fields are full ISO datetimes rather than bare `YYYY-MM-DD`. */
export function formatUtcDate(iso: string | null): string {
  if (!iso) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!match) return iso;
  const local = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return local.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

/** "18 Days Left". Returns null when the server did not supply a count — a countdown is never fabricated,
 * and in particular never defaults to "0 Days Left". */
export function daysLeftLabel(days: number | null): string | null {
  if (days === null || days < 1) return null;
  return `${days} ${days === 1 ? 'Day' : 'Days'} Left`;
}
